import { ContactPerson } from '../../../../../types/contactPerson'

interface AddPrimaryContactFromMainFieldsProps {
  contacts: ContactPerson[]
  editedIndex: number
  email?: string
  firstName?: string
  lastName?: string
}

export const addPrimaryContactFromMainFields = ({
  contacts,
  editedIndex,
  email,
  firstName,
  lastName,
}: AddPrimaryContactFromMainFieldsProps): ContactPerson[] => {
  const updatedContacts = [...contacts]

  updatedContacts[editedIndex] = {
    ...updatedContacts[editedIndex],
    email,
    firstName,
    lastName,
  }

  return updatedContacts
}
